import React, { useState } from "react";
import { Col, Row, Upload, message, Form, Input } from "antd";
import imageCompression from "browser-image-compression";
import ImgCrop from "antd-img-crop";
import { PlusOutlined } from "@ant-design/icons";

import { Domain, request } from "../../../../config/API";
import getBase64 from "../../../../helpers/getBase64";
import authHeader from "../../../../redux/services/authHeader";
import shortId from "shortid";
import PreviewImage from "./PreviewImage";

const Gallery = ({ form }) => {
  const [fileList, setFileList] = useState([]);

  const controller = new AbortController();
  const options = {
    signal: controller.signal,
    maxSizeMB: 1,
  };

  const postImage = ({ file, onSuccess, onError }) => {
    const formData = new FormData();
    imageCompression(file, options)
      .then(function (compressedFile) {
        formData.append("images", compressedFile);
        request
          .post("qr/images", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              ...authHeader(),
            },
          })
          .then(({ data: { data } }) => {
            onSuccess();
            const newData = {
              uid: shortId(),
              name: data.images,
              status: "done",
              url: Domain + "/data/" + data.images,
            };
            const list = [...fileList, newData];
            setFileList(list);
            form.setFieldValue(
              "images",
              list.map((img) => img?.name)
            );
          })
          .catch((err) => {
            console.error(err.response);
            message.error(
              err?.response?.data?.data || "Image size limit 500kb"
            );
            onError();
          });

        return;
      })
      .catch(function (error) {
        console.error(error.message);
      });
  };

  const [previewImage, setPreviewImage] = useState("");
  const [previewVisible, setPreviewVisible] = useState(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
  };

  const handleImageRemove = (image, key, images) => {
    form.setFieldValue(
      key,
      images.filter((img) => img?.name !== image).map((img) => img?.name)
    );
  };
  return (
    <>
      <Row span={24}>
        <Col xs={24} md={4}>
          <h4>Images</h4>
          <p className="subText">Max 3/{fileList.length}</p>
          <p className="subText">Size: 500 KB</p>
        </Col>
        <Col xs={24} md={20}>
          <ImgCrop
            rotate
            modalTitle="Crop Image *Image previews can be blurred. It will not affect quality of image."
            quality={1}
            aspect={9 / 6}
            modalWidth={720}
            shape="rect"
            fillColor="#00000000"
          >
            <Upload
              className="fileList-upload-images"
              maxCount={3}
              customRequest={postImage}
              listType="picture-card"
              fileList={fileList}
              onPreview={handlePreview}
              onRemove={(e) => handleImageRemove(e?.name, "images", fileList)}
              onChange={(e) => {
                setFileList(fileList.filter((f) => f.uid !== e?.file?.uid));
              }}
              accept="image/*"
            >
              {fileList.length >= 3 ? null : <PlusOutlined />}
            </Upload>
          </ImgCrop>
        </Col>
      </Row>
      <Form.Item name="images">
        <Input type="hidden"></Input>
      </Form.Item>
      <PreviewImage
        previewImage={previewImage}
        previewVisible={previewVisible}
        setPreviewVisible={setPreviewVisible}
      ></PreviewImage>
    </>
  );
};

export default Gallery;
